// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"615ce177","263":"de751dbb","269":"d1c03162","297":"da445865","351":"0de5b4d7","352":"03aa5930"}[chunkId] + ".chunk.js";
};